'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function CUFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", { id: "mantine-7z1zwn5h8", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-kbgfkrt43", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-y4qk08udf" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-m0vstjzof", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-9vy0yv1t2" })), /* @__PURE__ */ React.createElement("path", { id: "mantine-y4qk08udf", d: "M0 0h32v24H0z" }), /* @__PURE__ */ React.createElement("path", { id: "mantine-9vy0yv1t2", d: "M0 0v24l18-12z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-7z1zwn5h8)" }, /* @__PURE__ */ React.createElement("use", { fill: "#3d58db", xlinkHref: "#mantine-y4qk08udf" }), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#3d58db",
        stroke: "#f7fcff",
        strokeWidth: "4",
        d: "M-2 8h36v8H-2z",
        mask: "url(#mantine-kbgfkrt43)"
      }
    ), /* @__PURE__ */ React.createElement("use", { fill: "#e31d1c", xlinkHref: "#mantine-9vy0yv1t2" }), /* @__PURE__ */ React.createElement("g", { fill: "#f7fcff", mask: "url(#mantine-m0vstjzof)" }, /* @__PURE__ */ React.createElement("path", { d: "M6.688 14.217l-3.672 1.938 1.788-3.894-2.278-2.08 2.812-.104 1.35-3.52 1.03 3.52h2.808l-1.872 2.184 1.489 3.894z" }))))
  );
}

export { CUFlag };
//# sourceMappingURL=CU.mjs.map
